export default function isNumber(value) {
    return Number.isFinite(value) || value === Infinity || value === -Infinity;
}
;
